import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { PublicHeader } from '@/components/PublicHeader';

export default function Landing() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleStartChallenge = () => {
    navigate('/auth?mode=signup');
  };

  const handleSignIn = () => {
    navigate('/auth?mode=signin');
  };

  return (
    <div className="min-h-screen-safe flex flex-col bg-background">
      <PublicHeader />
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-8">
        {/* Feature Blocks with Emojis */}
        <section className="w-full max-w-md mb-10">
          <div className="space-y-6">
            <div className="text-center">
              <div className="text-3xl mb-2">🫵</div>
              <h3 className="font-medium text-foreground">{t('landingStep1Title')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landingStep1Desc')}
              </p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🗣️🫂</div>
              <h3 className="font-medium text-foreground">{t('landingStep2Title')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landingStep2Desc')}
              </p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🍺🍷🥃</div>
              <h3 className="font-medium text-foreground">{t('landingStep3Title')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landingStep3Desc')}
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action - Demo first, then main CTA */}
        <section className="text-center">
          <div className="mb-4">
            <button
              type="button"
              onClick={() => navigate('/demo')}
              className="text-sm text-primary hover:text-primary/80 font-medium transition-colors"
            >
              {t('landingDemoCta')}
            </button>
          </div>
          <Button 
            size="lg" 
            onClick={handleStartChallenge}
            className="mb-4"
          >
            {t('landingCta')}
          </Button>
          <div>
            <button
              type="button"
              onClick={handleSignIn}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {t('landingSignIn')}
            </button>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-4 text-center">
        <p className="text-xs text-muted-foreground">
          {t('footerCopyright').replace('{year}', new Date().getFullYear().toString())}
        </p>
      </footer>
    </div>
  );
}
